var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-tooltip",
        {
          attrs: { effect: "light", placement: "top" },
          scopedSlots: _vm._u(
            [
              {
                key: "content",
                fn: function () {
                  return [_vm._t("tooltip")]
                },
                proxy: true,
              },
            ],
            null,
            true
          ),
        },
        [
          _c(
            "svg",
            {
              staticClass: "pie",
              attrs: { height: _vm.computedHeight, width: _vm.computedHeight },
            },
            _vm._l(_vm.dataObjects.slice().reverse(), function (item) {
              return _c("circle", {
                key: item.key,
                style: {
                  strokeDasharray: `${item.relativeSize} ${_vm.circumference}`,
                  strokeDashoffset: item.offset,
                  strokeWidth: _vm.stroke,
                },
                attrs: { r: _vm.radius, cx: "50%", cy: "50%" },
              })
            }),
            0
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }